import { ApiError } from './api';

export const PROJECT_NUMBER_DUPLICATE_WARNING =
  'Another project already has this number — check it';

export function parseProjectNumberDraft(
  draft: string,
): { value: number | null; error?: string } {
  const trimmed = draft.trim();
  if (trimmed === '') return { value: null };
  const value = Number(trimmed);
  if (!Number.isInteger(value) || value <= 0) {
    return { value: null, error: 'Project number must be a positive whole number.' };
  }
  return { value };
}

export function projectNumberRequestError(error: unknown, fallback: string): string {
  if (error instanceof ApiError && error.status === 409) {
    return PROJECT_NUMBER_DUPLICATE_WARNING;
  }
  return error instanceof Error ? error.message : fallback;
}
